"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var system_1 = require("@mui/system");
var TableRow_1 = __importDefault(require("atomicComponents/atoms/Table/TableRow"));
var ServicesTableRow = (0, system_1.styled)(TableRow_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing(0, 1),
        position: 'relative',
        borderRadius: theme.spacing(1),
        ':hover': {
            backgroundColor: theme.palette.primary.outlined.hover.backgroundColor,
            cursor: 'pointer',
            '& .MuiIconButton-root': {
                visibility: 'visible',
            },
            ' .MuiButton-root': {
                color: theme.palette.riverstone,
                cursor: 'text',
                borderColor: theme.palette.primary.light,
            },
        },
        ':focus-visible': {
            boxShadow: "0px 0px 0px 2px rgba(255, 255, 255, 0.9), 0px 0px 0px 3px ".concat(theme.palette.primary.main),
            outlineColor: 'transparent',
        },
    });
});
exports.default = ServicesTableRow;
